import store from '../store';
import Assessment from '../models/Assessment';

export default {

    methods: {
        loadCheckData(assessment) {
            const formData = {
                company: assessment.organisationName,
                address: assessment.organisationStreet,
                postal: assessment.organisationPostcode,
                city: assessment.organisationLocation,
                country: assessment.organisationCountry,
                website: assessment.organisationWebsite,
                gender: assessment.contactGender,
                firstname: assessment.contactFirstname,
                lastname: assessment.contactLastname,
                position: assessment.contactRole,
                email: assessment.contactEmail,
                phone: assessment.contactPhone,
                coach: assessment.coach,
                sector: assessment.sector,

                employees: '',
                turnover: [],
                content: '',
                content_notes: '',
                channels_notes: '',
                strongestChannel_notes: '',
                strongestChannel_onlineDirect: '',
                strongestChannel_onlineIndirect: '',
                strongestChannel_offlineDirect: '',
                strongestChannel_offlineIndirect: '',
                budget: '',
                budget_online: '',
                budget_notes: '',
                monitoring_notes: '',
                systems_cms_notes: '',
                systems_dam_notes: '',
                systems_pim_notes: '',
                systems_crm_notes: '',
                systems_erp_notes: '',

                channels: [],
                monitoring: [],
                systems_cms: [],
                systems_dam: [],
                systems_pim: [],
                systems_crm: [],
                systems_erp: [],
            };

            assessment.checkAnswers.forEach((row) => {
                const value = row.option === null ? row.value : row.option;

                if (row.key === 'turnover_from') {
                    formData.turnover[0] = row.value;
                } else if (row.key === 'turnover_to') {
                    formData.turnover[1] = row.value;
                } else if (formData[row.key] instanceof Array) {
                    formData[row.key].push(value);
                } else {
                    formData[row.key] = value;
                }
            });

            return formData;
        },

        saveCheckData(formData) {
            const assessment = new Assessment({});
            let coach = formData.coachId;

            if (store.getters['user/isCoach']) {
                coach = store.getters['user/user'].resourceId;
            }

            assessment.organisationName = formData.company;
            assessment.organisationStreet = formData.address;
            assessment.organisationPostcode = formData.postal;
            assessment.organisationLocation = formData.city;
            assessment.organisationCountry = formData.country;
            assessment.organisationWebsite = formData.website;
            assessment.contactGender = formData.gender;
            assessment.contactFirstname = formData.firstname;
            assessment.contactLastname = formData.lastname;
            assessment.contactRole = formData.position;
            assessment.contactEmail = formData.email;
            assessment.contactPhone = formData.phone;
            assessment.sector = formData.sector;
            assessment.customer = {
                name: formData.company,
                street: formData.address,
                postcode: formData.postal,
                location: formData.city,
                country: formData.country,
                website: formData.website,
                coach,
            };

            const answers = [
                { key: 'employees', value: `${formData.employees}` },
                { key: 'turnover_from', value: `${formData.turnover[0]}` },
                { key: 'turnover_to', value: `${formData.turnover[1]}` },
                { key: 'content', value: `${formData.content}` },
                { key: 'content_notes', value: `${formData.content_notes}` },
                { key: 'channels_notes', value: `${formData.channels_notes}` },
                { key: 'strongestChannel_notes', value: `${formData.strongestChannel_notes}` },
                { key: 'strongestChannel_onlineDirect', value: `${formData.strongestChannel_onlineDirect}` },
                { key: 'strongestChannel_onlineIndirect', value: `${formData.strongestChannel_onlineIndirect}` },
                { key: 'strongestChannel_offlineDirect', value: `${formData.strongestChannel_offlineDirect}` },
                { key: 'strongestChannel_offlineIndirect', value: `${formData.strongestChannel_offlineIndirect}` },
                { key: 'budget', value: `${formData.budget}` },
                { key: 'budget_online', value: `${formData.budget_online}` },
                { key: 'budget_notes', value: `${formData.budget_notes}` },
                { key: 'monitoring_notes', value: `${formData.monitoring_notes}` },
                { key: 'systems_cms_notes', value: `${formData.systems_cms_notes}` },
                { key: 'systems_dam_notes', value: `${formData.systems_dam_notes}` },
                { key: 'systems_pim_notes', value: `${formData.systems_pim_notes}` },
                { key: 'systems_crm_notes', value: `${formData.systems_crm_notes}` },
                { key: 'systems_erp_notes', value: `${formData.systems_erp_notes}` },
            ];

            [
                'channels',
                'monitoring',
                'systems_cms',
                'systems_dam',
                'systems_pim',
                'systems_crm',
                'systems_erp',
            ].forEach((key) => {
                if (!formData[key]) {
                    return;
                }

                formData[key].forEach((option) => {
                    answers.push({ key, option });
                });
            });

            assessment.setCheckCompleted(answers);

            return assessment;
        },
    },
};
